/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';
import * as Logos from './images';

const COLORS = {
  black: '#000000',
  white: '#FFFFFF',
};

const CallSign = ({ callSign = '', color = 'white' }) => {
  const logoColor = COLORS[color];
  const Component = Logos[callSign.replace('-', '')] || Logos.FEED;
  return (
    <Component
      style={{ height: '100%', width: '100%' }}
      color={logoColor}
      data-test={`${callSign}-callSign`}
    />
  );
};

CallSign.propTypes = {
  callSign: PropTypes.string,
  color: PropTypes.string,
};

CallSign.defaultProps = {
  color: 'white',
  callSign: 'FEED',
};

export default CallSign;
